var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLeftEndArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.998 11.062a.938.938 0 0 1-1.487.759L.309 6.606a.749.749 0 0 1 0-1.212L7.508.179a.94.94 0 0 1 1.487.76v3.096L14.52.17A.941.941 0 0 1 16 .942v10.116a.946.946 0 0 1-1.484.772L8.998 7.965v3.097Zm0-4.928 5.5 3.85V2.016l-5.5 3.85v.268ZM2.028 6l5.47 3.962V2.038L2.029 6Z"
})));
export default SvgLeftEndArrowIcon;